export default __webpack_public_path__ + "static/media/turkgo-screenshot-03.dac58cd5.png";